module.exports = __webpack_public_path__ + "static/img/equipmentu2.cfcf3407.webp";